import * as React from 'react';
import * as async from '../helpers';

var getDefaultErrorNode = function getDefaultErrorNode(error) {
  return React.createElement("span", {
    style: {
      color: 'red'
    }
  }, "Error: ", error.message);
};

var getDefaultErrorsNode = function getDefaultErrorsNode(error) {
  return Array.isArray(error) ? error.map(function (e, i) {
    return React.createElement(React.Fragment, {
      key: i
    }, i ? React.createElement("br", null) : null, getDefaultErrorNode(e));
  }) : getDefaultErrorNode(error);
};

export var AsyncViewWrapper = React.memo(function (_a) {
  var asyncData = _a.asyncData,
      topRenderLoading = _a.topRenderLoading,
      bottomRenderLoading = _a.bottomRenderLoading,
      forceLoading = _a.forceLoading,
      topRenderError = _a.topRenderError,
      bottomRenderError = _a.bottomRenderError,
      forceError = _a.forceError,
      children = _a.children;
  var loading = forceLoading || (Array.isArray(asyncData) ? async.isAnyInProgressOrInvalidated.apply(async, asyncData) : async.isInProgressOrInvalidated(asyncData));
  var error = forceError || (Array.isArray(asyncData) ? asyncData.filter(async.isError).map(function (ad) {
    return ad.error;
  }) : async.isError(asyncData) ? asyncData.error : undefined);
  return React.createElement(React.Fragment, null, (Array.isArray(error) ? error.length > 0 : error) && (topRenderError ? topRenderError(error) : bottomRenderError ? null : getDefaultErrorsNode(error)), loading && (topRenderLoading ? topRenderLoading() : bottomRenderLoading ? null : 'Loading...'), children, loading && (bottomRenderLoading ? bottomRenderLoading() : topRenderError ? null : 'Loading...'), (Array.isArray(error) ? error.length > 0 : error) && (bottomRenderError ? bottomRenderError(error) : topRenderError ? null : getDefaultErrorsNode(error)));
});